import { Selector } from '@ngxs/store';
import { MobilephoneSearchState, MobilephoneSearchStateModel } from './mobilephone-search.state';
import { HardwareVariantGroup } from '../../models/mobilephone-variant';

export class MobilePhoneSearchSelectors {
  @Selector([MobilephoneSearchState])
  public static getState(state: MobilephoneSearchStateModel): MobilephoneSearchStateModel {
    return state;
  }

  @Selector([MobilephoneSearchState])
  public static mobilePhoneResults(state: MobilephoneSearchStateModel): HardwareVariantGroup[] {
    return state.searchResults;
  }
}
